import { GooglePlacesOptions as Options } from "app/shared/directives/google-places-autocomplete/google-places-autocomplete.directive";

export const OPTIONS: Partial<Options> = {
    componentRestrictions: {
        country: 'AU'
    },
}